import { Component, Inject, Input } from "@angular/core";
import { CommonModule } from '@angular/common';
import { FieldOkItemComponent } from "@softline/dynamic";

@Component({
    selector: 'soft-field-ok-data-view',
    imports: [CommonModule],
    templateUrl: './lagerstamm.list-view.html',
    styleUrls: ['./lagerstamm.list-view.scss']
})
export class LagerstammListView implements FieldOkItemComponent<any>{

  @Input() item: any;

  constructor() {
  }
}
